import { createSelector } from 'reselect';
import { getWorkOrderFlowEnabled } from 'lib/selectors/getWorkOrderFlowEnabled';
import { getIsMachineMappedToErp } from 'lib/selectors/getIsMachineMappedToErp';

/**
 * Determines if work order flow is enabled for the current machine.
 *
 * Work order flow requires:
 * - Work order flow to be enabled in company settings
 * - Machine to be mapped to ERP resources (direct or via machine groups)
 *
 * This enables operators to work with ERP-driven work orders and operations.
 */
const getIsWorkOrderFlowEnabled = createSelector(
  [getWorkOrderFlowEnabled, getIsMachineMappedToErp],
  (workOrderFlowEnabled, isMachineMappedToErp) => {
    return workOrderFlowEnabled && isMachineMappedToErp;
  }
);

export { getIsWorkOrderFlowEnabled };
